import { BlockedMatchModalParams, Matchs, Players } from "../../types";

export type LaunchAttemptResolution =
  | { type: "launch" }
  | {
      type: "player_conflict";
      blockedMatchModalParams: BlockedMatchModalParams;
    }
  | {
      type: "table_occupied";
      blockedTable: number;
      blockingMatchs: Matchs[];
    };

// Pour la création d'un match : doit-il être DOUBLON ?
export function checkMatchCreationBlockedByEnCours(
  matchToCreate: Matchs,
  matchs: Matchs[]
): {
  isBlocked: boolean;
  blockingMatches: Matchs[];
} {
  const blockingMatches = matchs
    .filter((match) => match.status === "ENCOURS")
    .filter((enCoursMatch) =>
      enCoursMatch.matchsPlayerParticipations.some((p) =>
        matchToCreate.matchsPlayerParticipations.some(
          (mp) => mp.playersId === p.playersId
        )
      )
    );
  return { isBlocked: blockingMatches.length > 0, blockingMatches };
}

// Pour le lancement d'un match : quels matchs en attente (CREE, LIBERE) passent à DOUBLON ?
export function findMatchesToSetDoublonOnLaunch(
  launchedMatch: Matchs,
  matchs: Matchs[]
): Matchs[] {
  const launchedPlayerIds = new Set(
    launchedMatch.matchsPlayerParticipations.map((p) => p.playersId)
  );

  return matchs.filter(
    (match) =>
      match.id !== launchedMatch.id &&
      (match.status === "CREE" || match.status === "LIBERE") &&
      match.matchsPlayerParticipations.some((p) =>
        launchedPlayerIds.has(p.playersId)
      )
  );
}

export function getEncoursMatchsOnTable(
  match: Matchs,
  matchs: Matchs[]
): Matchs[] {
  if (!match.tableId) {
    return [];
  }
  return matchs.filter(
    (m) =>
      m.status === "ENCOURS" &&
      m.tableId === match.tableId &&
      m.id !== match.id
  );
}

function checkIsMatchLaunchable(
  matchToLaunch: Matchs,
  matchs: Matchs[]
): {
  isMatchLaunchable: boolean;
  blockedMatchModalParams: BlockedMatchModalParams;
} {
  const { isBlocked, blockingMatches } = checkMatchCreationBlockedByEnCours(
    matchToLaunch,
    matchs
  );
  return {
    isMatchLaunchable: !isBlocked,
    blockedMatchModalParams: {
      blockingPlayers: blockingMatches.map((m) => ({
        player: { id: "", name: "", surname: "" } as Players,
        match: m,
      })),
    },
  };
}

/** Priorité : conflit joueur, puis table occupée, sinon lancement. */
export function resolveLaunchAttempt(
  match: Matchs,
  matchs: Matchs[]
): LaunchAttemptResolution {
  const { isMatchLaunchable, blockedMatchModalParams } =
    checkIsMatchLaunchable(match, matchs);
  const matchsOnTable = getEncoursMatchsOnTable(match, matchs);

  if (!isMatchLaunchable) {
    return {
      type: "player_conflict",
      blockedMatchModalParams: {
        ...blockedMatchModalParams,
        occupiedTableId:
          matchsOnTable.length > 0 ? match.tableId : undefined,
      },
    };
  }

  if (matchsOnTable.length > 0) {
    return {
      type: "table_occupied",
      blockedTable: match.tableId!,
      blockingMatchs: matchsOnTable,
    };
  }

  return { type: "launch" };
}

export default checkIsMatchLaunchable;
